import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import useResponsiveness from '@/hooks/useResponsiveness';
import { getCatalogPalette } from '@/components/Catalog/catalogPalette';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import DiscoveryPreview from './DiscoveryPreview';

export default function DiscoveryInvitation({ work = false, onExplore }) {
  const { theme } = useTheme();
  const { isXS } = useResponsiveness();
  const palette = getCatalogPalette(theme);
  const kinds = work ? ['website', 'slides', 'sheet'] : ['game', 'recipe', 'diagram'];
  return <View style={styles.wrap} testID="discovery-invitation">
    <Pressable accessibilityRole="button" accessibilityLabel={work ? 'Explore Work ideas' : 'Explore For you'}
      accessibilityHint="Scrolls to the discovery feed below" onPress={onExplore}
      style={({ hovered, pressed }) => [styles.card, isXS && styles.mobileCard, {
        backgroundColor: hovered || pressed ? palette.hover : palette.surface, borderColor: palette.border,
      }]}>
      {!isXS && <View style={[styles.previews, { pointerEvents: 'none' }]}>
        {kinds.map((kind, index) => <View key={kind} style={[styles.preview, { transform: [{ rotate: `${(index - 1) * 7}deg` }], zIndex: 3 - index, borderColor: palette.surface }]}>
          <DiscoveryPreview kind={kind} height={58} />
        </View>)}
      </View>}
      <View style={styles.copy}>
        <Text size={isXS ? 'n' : 'l'} weight="medium">{work ? 'Find your next project' : 'See what you can make'}</Text>
        <Text size="s" color="secondary" numberOfLines={2}>{work ? 'Research, documents, websites, and more.' : 'Fresh ideas, useful tools, and places to explore.'}</Text>
      </View>
      <View style={[styles.arrow, { backgroundColor: palette.control }]}><Icon name="arrow-down" size={16} color={palette.ink} /></View>
    </Pressable>
  </View>;
}
const styles = StyleSheet.create({
  wrap: { width: '100%', maxWidth: 920, alignSelf: 'center', paddingHorizontal: 20, paddingTop: 12, paddingBottom: 20 },
  card: { borderWidth: 1, borderRadius: 22, paddingHorizontal: 24, paddingVertical: 20, minHeight: 104, flexDirection: 'row', alignItems: 'center', gap: 24 },
  mobileCard: { paddingHorizontal: 18, paddingVertical: 16, minHeight: 96, gap: 14 },
  copy: { flex: 1, minWidth: 0, gap: 5 },
  previews: { flexDirection: 'row', alignItems: 'center', paddingLeft: 2 },
  preview: { width: 78, height: 62, borderRadius: 10, overflow: 'hidden', borderWidth: 2, marginLeft: -6 },
  arrow: { width: 36, height: 36, borderRadius: 18, alignItems: 'center', justifyContent: 'center' },
});
